import { call, select, put } from "redux-saga/effects";
import { updateConferenceParticipantListAction } from "../updateConferenceParticipantList/action";
import { selectCallSessions, setCallSessions } from "../../../state/callSessions/callSessionsSlice";
import cirrusClient from "../../../services/api/cirrus-client";


export function* unmuteConferenceParticipantSaga(action) {
    try {
        const { conferenceUri, participantId } = action.payload;

        // Update the participant's status in the local state
        const callSessions = yield select(selectCallSessions);
        const updatedSessions = callSessions.map(session => {
            if (session.isConference && session.session.remoteIdentity.uri.toString() === conferenceUri) {
                session.conferenceList = session.conferenceList.map(participant =>
                    participant.participant_match  === participantId ? { ...participant, mode: 'active' } : participant
                );
            }
            return session;
        });
        yield put(setCallSessions(updatedSessions));

        const apiUrl = '?object=participant&action=unmute'
        const params = {
            conference_match: conferenceUri,
            participant_match: participantId,
        };
        yield call(cirrusClient.post, apiUrl, params);

        // After successful API call, update the participant list
        // yield put(updateConferenceParticipantListAction({ conferenceUri }));

    } catch (error) {
        console.error('Error unmuting participant in the conference', error);
    }


}